import { render, staticRenderFns } from "./Login-Studio.vue?vue&type=template&id=287f54f9&scoped=true&"
import script from "./Login-Studio.vue?vue&type=script&lang=js&"
export * from "./Login-Studio.vue?vue&type=script&lang=js&"
import style0 from "./Login-Studio.vue?vue&type=style&index=0&id=287f54f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f54f9",
  null
  
)

export default component.exports